import React, { useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Helmet } from "react-helmet";
import VACForm from "./VACForm";
import DACForm from "./DACForm";

const FillForm = () => {
  const [activeTab, setActiveTab] = useState("VAC");

  return (
    <div>
      <Helmet>
        <title>eksplode! | Parent Consent Form</title>
      </Helmet>
      <Breadcrumb title={"Form"} />

      <div className="container mt-4">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "VAC" ? "active" : ""}`}
              onClick={() => setActiveTab("VAC")}
            >
              VAC
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "DAC" ? "active" : ""}`}
              onClick={() => setActiveTab("DAC")}
            >
              DAC
            </button>
          </li>
        </ul>
      </div>

      <div className="container mt-3">
        {activeTab === "VAC" && <VACForm />}
        {activeTab === "DAC" && <DACForm />}
      </div>
    </div>
  );
};

export default FillForm;
